import { render, staticRenderFns } from "./Nakalibros.vue?vue&type=template&id=47cf698e&scoped=true&"
import script from "./Nakalibros.vue?vue&type=script&lang=js&"
export * from "./Nakalibros.vue?vue&type=script&lang=js&"
import style0 from "./Nakalibros.vue?vue&type=style&index=0&id=47cf698e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cf698e",
  null
  
)

export default component.exports